import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_internal_sales_debit_note_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_validate_error: fromDatatype.VarcharDatatypeInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    location_guid: fromDatatype.GuidDataFieldInterface;
    location_validate_error: fromDatatype.VarcharDatatypeInterface;
    sales_agent: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    txn_date_error: fromDatatype.VarcharDatatypeInterface;
    // validity_days: fromDatatype.NumericDatatypeInterface;
    // validity_days_error: fromDatatype.VarcharDatatypeInterface;
    // validity_end_date: fromDatatype.TimestampTzDatatypeInterface;
    hdr_ref_no: fromDatatype.VarcharDatatypeInterface;
    hdr_ref_no_error: fromDatatype.VarcharDatatypeInterface;
    credit_terms: fromDatatype.VarcharDatatypeInterface;
    credit_limit: fromDatatype.VarcharDatatypeInterface;
    hdr_description: fromDatatype.TextDatatypeInterface;
    hdr_remarks: fromDatatype.TextDatatypeInterface;
    doc_currency: fromDatatype.VarcharDatatypeInterface;
    doc_currency_error: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    entity_guid: fromDatatype.GuidDataFieldInterface;
    entity_validate_error: fromDatatype.VarcharDatatypeInterface;
    billing_name: fromDatatype.VarcharDatatypeInterface;
    billing_email: fromDatatype.VarcharDatatypeInterface;
    billing_phone: fromDatatype.VarcharDatatypeInterface;
    billing_address_line_1: fromDatatype.TextDatatypeInterface;
    billing_address_line_2: fromDatatype.TextDatatypeInterface;
    billing_address_line_3: fromDatatype.TextDatatypeInterface;
    billing_address_line_4: fromDatatype.TextDatatypeInterface;
    billing_address_line_5: fromDatatype.TextDatatypeInterface;
    billing_country: fromDatatype.VarcharDatatypeInterface;
    billing_state: fromDatatype.VarcharDatatypeInterface;
    billing_city: fromDatatype.VarcharDatatypeInterface;
    billing_postcode: fromDatatype.VarcharDatatypeInterface;
    shipping_name: fromDatatype.VarcharDatatypeInterface;
    shipping_email: fromDatatype.VarcharDatatypeInterface;
    shipping_phone: fromDatatype.VarcharDatatypeInterface;
    shipping_address_line_1: fromDatatype.TextDatatypeInterface;
    shipping_address_line_2: fromDatatype.TextDatatypeInterface;
    shipping_address_line_3: fromDatatype.TextDatatypeInterface;
    shipping_address_line_4: fromDatatype.TextDatatypeInterface;
    shipping_address_line_5: fromDatatype.TextDatatypeInterface;
    shipping_country: fromDatatype.VarcharDatatypeInterface;
    shipping_state: fromDatatype.VarcharDatatypeInterface;
    shipping_city: fromDatatype.VarcharDatatypeInterface;
    shipping_postcode: fromDatatype.VarcharDatatypeInterface;
    settlement_or_item_code: fromDatatype.VarcharDatatypeInterface;
    settlement_or_item_code_error: fromDatatype.VarcharDatatypeInterface;
    item_ref_no: fromDatatype.TextDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_type_error: fromDatatype.VarcharDatatypeInterface;
    stl_amount: fromDatatype.NumericDatatypeInterface;
    transaction_no: fromDatatype.VarcharDatatypeInterface;
    stl_remarks: fromDatatype.TextDatatypeInterface;
    qty: fromDatatype.NumericDatatypeInterface;
    qty_error: fromDatatype.VarcharDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    amount_error: fromDatatype.VarcharDatatypeInterface;
    tax_gst_code: fromDatatype.VarcharDatatypeInterface;
    tax_gst_pct: fromDatatype.NumericDatatypeInterface;
    tax_gst_error: fromDatatype.VarcharDatatypeInterface;
    tax_wht_code: fromDatatype.VarcharDatatypeInterface;
    tax_wht_pct: fromDatatype.NumericDatatypeInterface;
    tax_wht_error: fromDatatype.VarcharDatatypeInterface;
    tax_amount: fromDatatype.NumericDatatypeInterface;
    item_serial_no: fromDatatype.JsonDatatypeInterface;
    item_batch_no: fromDatatype.JsonDatatypeInterface;
    item_bin_no: fromDatatype.JsonDatatypeInterface;
    item_tracking_id: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_id_guid: fromDatatype.GuidDataFieldInterface;
    posting_status_error: fromDatatype.VarcharDatatypeInterface;
    contra_error: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    item_serial_no_error: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_internal_sales_debit_note_import_file_helper_RowClass implements bl_fi_internal_sales_debit_note_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_validate_error: fromDatatype.VarcharDatatypeInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    location_guid: fromDatatype.GuidDataFieldInterface;
    location_validate_error: fromDatatype.VarcharDatatypeInterface;
    sales_agent: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    txn_date_error: fromDatatype.VarcharDatatypeInterface;
    // validity_days: fromDatatype.NumericDatatypeInterface;
    // validity_days_error: fromDatatype.VarcharDatatypeInterface;
    // validity_end_date: fromDatatype.TimestampTzDatatypeInterface;
    hdr_ref_no: fromDatatype.VarcharDatatypeInterface;
    hdr_ref_no_error: fromDatatype.VarcharDatatypeInterface;
    credit_terms: fromDatatype.VarcharDatatypeInterface;
    credit_limit: fromDatatype.VarcharDatatypeInterface;
    hdr_description: fromDatatype.TextDatatypeInterface;
    hdr_remarks: fromDatatype.TextDatatypeInterface;
    doc_currency: fromDatatype.VarcharDatatypeInterface;
    doc_currency_error: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    entity_guid: fromDatatype.GuidDataFieldInterface;
    entity_validate_error: fromDatatype.VarcharDatatypeInterface;
    billing_name: fromDatatype.VarcharDatatypeInterface;
    billing_email: fromDatatype.VarcharDatatypeInterface;
    billing_phone: fromDatatype.VarcharDatatypeInterface;
    billing_address_line_1: fromDatatype.TextDatatypeInterface;
    billing_address_line_2: fromDatatype.TextDatatypeInterface;
    billing_address_line_3: fromDatatype.TextDatatypeInterface;
    billing_address_line_4: fromDatatype.TextDatatypeInterface;
    billing_address_line_5: fromDatatype.TextDatatypeInterface;
    billing_country: fromDatatype.VarcharDatatypeInterface;
    billing_state: fromDatatype.VarcharDatatypeInterface;
    billing_city: fromDatatype.VarcharDatatypeInterface;
    billing_postcode: fromDatatype.VarcharDatatypeInterface;
    shipping_name: fromDatatype.VarcharDatatypeInterface;
    shipping_email: fromDatatype.VarcharDatatypeInterface;
    shipping_phone: fromDatatype.VarcharDatatypeInterface;
    shipping_address_line_1: fromDatatype.TextDatatypeInterface;
    shipping_address_line_2: fromDatatype.TextDatatypeInterface;
    shipping_address_line_3: fromDatatype.TextDatatypeInterface;
    shipping_address_line_4: fromDatatype.TextDatatypeInterface;
    shipping_address_line_5: fromDatatype.TextDatatypeInterface;
    shipping_country: fromDatatype.VarcharDatatypeInterface;
    shipping_state: fromDatatype.VarcharDatatypeInterface;
    shipping_city: fromDatatype.VarcharDatatypeInterface;
    shipping_postcode: fromDatatype.VarcharDatatypeInterface;
    settlement_or_item_code: fromDatatype.VarcharDatatypeInterface;
    settlement_or_item_code_error: fromDatatype.VarcharDatatypeInterface;
    item_ref_no: fromDatatype.TextDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_type_error: fromDatatype.VarcharDatatypeInterface;
    stl_amount: fromDatatype.NumericDatatypeInterface;
    transaction_no: fromDatatype.VarcharDatatypeInterface;
    stl_remarks: fromDatatype.TextDatatypeInterface;
    qty: fromDatatype.NumericDatatypeInterface;
    qty_error: fromDatatype.VarcharDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    amount_error: fromDatatype.VarcharDatatypeInterface;
    tax_gst_code: fromDatatype.VarcharDatatypeInterface;
    tax_gst_pct: fromDatatype.NumericDatatypeInterface;
    tax_gst_error: fromDatatype.VarcharDatatypeInterface;
    tax_wht_code: fromDatatype.VarcharDatatypeInterface;
    tax_wht_pct: fromDatatype.NumericDatatypeInterface;
    tax_wht_error: fromDatatype.VarcharDatatypeInterface;
    tax_amount: fromDatatype.NumericDatatypeInterface;
    item_serial_no: fromDatatype.JsonDatatypeInterface;
    item_batch_no: fromDatatype.JsonDatatypeInterface;
    item_bin_no: fromDatatype.JsonDatatypeInterface;
    item_tracking_id: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    generic_id_guid: fromDatatype.GuidDataFieldInterface;
    posting_status_error: fromDatatype.VarcharDatatypeInterface;
    contra_error: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    item_serial_no_error: fromDatatype.VarcharDatatypeInterface;
}